import { FunctionDeclaration, Type } from "@google/genai";

export const getStageInstructionsDeclaration: FunctionDeclaration = {
  name: "get_stage_instructions",
  description:
    "Get the system instructions for the next stage of the conversation.",
  parameters: {
    type: Type.OBJECT,
    properties: {},
    required: [],
  },
};

export const makeNoteDeclaration: FunctionDeclaration = {
  name: "make_note",
  description: "Saves a key-value pair of information to the user's profile.",
  parameters: {
    type: Type.OBJECT,
    properties: {
      key: {
        type: Type.STRING,
        description:
          "The category or key for the information (e.g., 'Skills', 'Experience').",
      },
      value: {
        type: Type.STRING,
        description: "The information to be saved.",
      },
    },
    required: ["key", "value"],
  },
};

export const suggestJobsDeclaration: FunctionDeclaration = {
  name: "suggest_jobs",
  description:
    "Suggests jobs to the user based on their stored profile notes. The system will automatically retrieve all notes from the backend and process them for job matching.",
  parameters: {
    type: Type.OBJECT,
    properties: {},
    required: [],
  },
};

export const endConversationDeclaration: FunctionDeclaration = {
  name: "end_conversation",
  description:
    "Ends the conversation with the user. Initiate when: 1) You are at the end of stage 5 AND you have performed all tasks and asked all relevant questions AND have thanked the user for the conversation. Or 2) The user has indicated they want to end the conversation early. NEVER coldly end the conversation without informing the user first.",
  parameters: {
    type: Type.OBJECT,
    properties: {},
    required: [],
  },
};
